import { render } from "./OutroComponent.vue?vue&type=template&id=f1eef75c&scoped=true"
import script from "./OutroComponent.vue?vue&type=script&lang=js"
export * from "./OutroComponent.vue?vue&type=script&lang=js"

import "./OutroComponent.vue?vue&type=style&index=0&id=f1eef75c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1eef75c"]])

export default __exports__